var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscriptionInitialPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 55,
    viewBox: "0 0 70 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5806 48L47.5806 53.7735V42.2265L37.5806 48ZM15 6H55V4H15V6ZM66 17V36H68V17H66ZM4 36V17H2V36H4ZM33.9677 47H15V49H33.9677V47ZM55 47H46.5806V49H55V47ZM2 36C2 43.1797 7.82031 49 15 49V47C8.92488 47 4 42.0751 4 36H2ZM66 36C66 42.0751 61.0751 47 55 47V49C62.1797 49 68 43.1797 68 36H66ZM55 6C61.0751 6 66 10.9249 66 17H68C68 9.8203 62.1797 4 55 4V6ZM15 4C7.8203 4 2 9.8203 2 17H4C4 10.9249 8.92487 6 15 6V4Z",
    fill: "#1866F6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_922"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 55,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionInitialPayment);
export default __webpack_public_path__ + "static/media/subscription_initial_payment.0f649c3d4c2f329499c0e8c52fbcb43e.svg";
export { ForwardRef as ReactComponent };